/**
 * Hook misji „nakarm oba koniki" — tylko EMIT (WP-V2-QC podłączy).
 */
import type { InteractEvent } from '../../interact/index.js';
import {
  STABLE_QUEST_ID,
  isFeedDef,
} from './objects.js';

export const INTERACT_BUS_EVENT = 'pieskowo:interact';

export type StableMissionPayload = {
  sceneKey: 'Stable';
  questId: typeof STABLE_QUEST_ID;
  stepKind: 'feed_horse';
  horseId: string;
  interact: InteractEvent;
};

export function isHorseFeedEvent(evt: InteractEvent): boolean {
  if (evt.type !== 'give' && evt.type !== 'consume' && evt.type !== 'snap') {
    return false;
  }
  if (!isFeedDef(evt.defId)) return false;
  // give do konia albo snap na strefę konia
  if (evt.type === 'snap') {
    return evt.snapZoneId === 'stable_horse_a' || evt.snapZoneId === 'stable_horse_b';
  }
  return true;
}

export function horseIdFromSnap(snapZoneId: string | undefined): string | null {
  if (snapZoneId === 'stable_horse_a') return 'horse-iskierka';
  if (snapZoneId === 'stable_horse_b') return 'horse-chmurka';
  return null;
}

/**
 * Payload misji z zdarzenia interact (karmienie konika).
 * horseId z payload / snapZone / fallback.
 */
export function stableMissionFromInteract(
  evt: InteractEvent,
  horseId?: string,
): StableMissionPayload | null {
  if (!isHorseFeedEvent(evt)) return null;
  const fromSnap = horseIdFromSnap(evt.snapZoneId);
  const fromPayload =
    evt.payload &&
    typeof evt.payload === 'object' &&
    'horseId' in evt.payload &&
    typeof (evt.payload as { horseId: unknown }).horseId === 'string'
      ? (evt.payload as { horseId: string }).horseId
      : null;
  const id = horseId ?? fromPayload ?? fromSnap;
  if (!id) return null;
  return {
    sceneKey: 'Stable',
    questId: STABLE_QUEST_ID,
    stepKind: 'feed_horse',
    horseId: id,
    interact: evt,
  };
}
